export default __webpack_public_path__ + "static/media/0.943044a7.jpg";